<template>
	<div class="d-flex">
		<b-button  v-if="multiple || !((!!value || !!editableImages))" variant="link" v-b-modal="'modal-'+id" class="plus_button m-1" >
			<i class="bx bx-plus plus"></i>
		</b-button>
		<div class="d-flex flex-wrap">
			<!-- For Video  -->
			<template v-if="uploadType && uploadType == 'video'">
				<template v-if="draggable">
					<template v-if="multiple && localEditableVideos && ((typeof localEditableVideos == 'string' && localEditableVideos != '') || localEditableVideos.length > 0 )">
						<div class="d-flex flex-row flex-nowrap overflow-auto">
							<draggable v-model="localEditableVideos" :options="{ direction: 'horizontal' }" tag="div" class="d-flex" @end="onDrag" :group="'videos'">
								<div class="mt-1 relative ml-2" v-for="(video, index) in localEditableVideos" :key="index">
									<div class="remove" @click="deleteVideo(video.id, deleteVideosPath)" v-if="!readonly">
										<i class="bx bx-x"></i>
									</div>
									<img :src="getPath(thumbPath + '/' +video.thumbnail)" @click="playVideo(mediaPath + '/' +video.filename)" class="rounded avatar-lg image_thumb" alt="Video Thumbnail" />
								</div>
							</draggable>
						</div>
					</template>
					<template v-if="!newData && multiple && currentVideos && ((typeof currentVideos == 'string' && currentVideos != '') || currentVideos.length > 0 )">
						<div class="d-flex flex-row flex-nowrap overflow-auto">
							<!-- <draggable v-model="currentVideos" :options="{ direction: 'horizontal' }" tag="div" @end="onDrag" class="d-flex" :group="'videos'"> -->
								<div class="mt-1 relative ml-2" v-for="(video, index) in currentVideos" :key="index">
									<div class="remove" @click="deleteVideo(video.id, deleteVideosPath, index)" v-if="!readonly">
										<i class="bx bx-x"></i>
									</div>
									<img :src="video.thumbnail" @click="playVideo(video.filename)" class="rounded avatar-lg image_thumb" alt="Video Thumbnail" />
								</div>
							<!-- </draggable> -->
						</div>
					</template>
				</template>

				<!-- Video without draggable -->
				<template v-else>
					<!-- Fetch from database  -->
					<template v-if="multiple && editableVideos && ((typeof editableVideos == 'string' && editableVideos != '') || editableVideos.length > 0 )" class="d-flex flex-wrap">
						<template>
							<div class="mt-1 relative ml-2" v-for="(video, index) in editableVideos" :key="index">
						
								<div class="remove" @click="deleteVideo(video.id, deleteVideosPath)" v-if="!readonly">
									<i class="bx bx-x"></i>
								</div>
								<img :src="getPath(thumbPath + '/' +video.thumbnail)" @click="playVideo(mediaPath + '/' +video.filename)" class="rounded avatar-lg image_thumb" alt="Video Thumbnail" />
							</div>
						</template>
					</template>
		
					<!-- When select to upload  -->
					<template v-if="!newData && multiple && currentVideos && ((typeof currentVideos == 'string' && currentVideos != '') || currentVideos.length > 0 )" class="d-flex flex-wrap">
						<template>
							<div class="mt-1 relative ml-2" v-for="(video, index) in currentVideos" :key="index">
			
								<div class="remove" @click="deleteVideo(video.id, deleteVideosPath, index)" v-if="!readonly">
									<i class="bx bx-x"></i>
								</div>
								<img :src="video.thumbnail" @click="playVideo(video.filename)" class="rounded avatar-lg image_thumb" alt="Video Thumbnail" />
				
							</div>
						</template>
					</template>
				</template>
			</template>
			
			<!-- For Image  -->
			<template v-else>
				<!-- Get from Database -->
				<template v-if="!multiple && editableImages && ((typeof editableImages == 'string' && editableImages != '') || editableImages.length > 0 )">
					<div class="mt-1 relative ml-2">
					<div class="remove" @click="deleteImage(editableImages,deletePath)" v-if="!readonly">
						<i class="bx bx-x"></i>
					</div>
					<img
						:src="getPath(mediaPath+'/'+editableImages)"
						alt
						class="rounded avatar-lg image_thumb"
						
						@click="openGallery(getPath(mediaPath+'/'+editableImages))"
					/>
					</div>
				</template>
				<template v-else-if="multiple && editableImages && ((typeof editableImages == 'string' && editableImages != '') || editableImages.length > 0 )" class="d-flex flex-wrap">
					<div class="mt-1 relative ml-2" v-for="(v,i) in editableImages" :key="i">
						<div class="remove" @click="deleteImage(v,deletePath)" v-if="!readonly">
							<i class="bx bx-x"></i>
						</div>
						<img
							:src="getPath(mediaPath+'/'+v)"
							alt
							class="rounded avatar-lg image_thumb"
							
							@click="openGallery(getPath(mediaPath+'/'+v))"
						/>
					</div>
				</template>

				<!-- When upload  -->
				<template v-if="multiple && value && ((typeof value == 'string' && value != '') || value.length > 0 )" class="d-flex flex-wrap">
					<div class="mt-1 relative ml-2" v-for="(v,i) in value" :key="i">
						<div class="remove" @click="deleteImage(v)" v-if="!readonly">
							<i class="bx bx-x"></i>
						</div>
						<img
							:src="getPath(baseUrl+'/'+v)"
							alt
							class="rounded avatar-lg image_thumb"
							
							@click="openGallery(getPath(baseUrl+'/'+v))"
						/>
					</div>
				</template>
				<template v-else-if="!multiple && value && ((typeof value == 'string' && value != '') || value.length > 0 )">
					<div class="mt-1 relative ml-2">
					<div class="remove" @click="deleteImage(value)" v-if="!readonly">
						<i class="bx bx-x"></i>
					</div>
					<img
						:src="getPath(baseUrl+'/'+value)"
						alt
						class="rounded avatar-lg image_thumb"
						
						@click="openGallery(getPath(baseUrl+'/'+value))"
					/>
					</div>
				</template>
			</template>
		</div>

		<b-modal :id="'modal-'+id" :ref="'my-modal-'+id" hide-footer centered>
		<vue-dropzone
			:id="id"
			ref="proDropzone"
			v-if="!readonly"
			:use-custom-slot="true"
			@vdropzone-removed-file="removeTmpFile"
			@vdropzone-max-files-exceeded="maxFileExceed"
			:options="dropzoneOpt"
			@vdropzone-error="checkFile"
			@vdropzone-file-added="changeThumbNail"
		>
			<!-- @vdropzone-file-added="checkFile" -->
			<div class="dropzone-custom-content">
			<div class="mb-1">
				<i class="display-4 text-muted bx bxs-cloud-upload"></i>
			</div>
			<h4>Drop files here or click to upload.</h4>
			</div>
		</vue-dropzone>
		<div class="d-flex justify-content-between mt-3">
			<b-button variant="secondary" @click="$refs['my-modal-'+id].hide()">{{trans.get('__JSON__.Cancel')}}</b-button>
			<b-button variant="primary" @click="saveImage" v-bind:disabled="this.files == ''">{{trans.get('__JSON__.Save')}}</b-button>
		</div>
		</b-modal>

		<LightBox
			v-if="media && media.length > 0"
			ref="lightbox"
			:media="media"
			:show-caption="false"
			:show-light-box="false"      
		/>
	</div>
</template>

<script>
import { routes } from "../../config/api_routes";
import vue2Dropzone from "vue2-dropzone";
import { commonService } from "../../services";
import LightBox from 'vue-image-lightbox';
import { error_message, replaceByDefault } from "../../Helper/helper";
import config from '../../config';
import draggable from "vuedraggable";

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

export default {
  components: { vueDropzone: vue2Dropzone, LightBox, draggable },
  props: {
    value: {
      default: "",
      type: [String, Array],
    },
    acceptedFiles: String,
    multiple: Boolean,
    id: String,
    editableImages: {
      default: "",
      type: [String, Array],
    },
	editableVideos: {
      default: "",
      type: [String, Array],
    },
	newData: Boolean,
	uploadType : String,
	maxFiles : Number,
    mediaPath: String,
	thumbPath: String,
    deletePath: String,
	deleteVideosPath: String,
    customParams: {
      default() {
        return {};
      },
      type: Object,
    },
    "image-deleted": {},
    readonly:{
      default: false,
      type: Boolean,
    },
	draggable: {
		default: false,
		type: Boolean,
	},
  },
  data() {
    return {
      files: [],
	  currentVideo : '',
	  currentVideos : [],
      baseUrl:'',
      replaceByDefault,
      media:[],
      config:config,
	  showPlayer: false,
	  localEditableVideos: [], // Local copy of editableVideos
      dropzoneOpt: {
        url: routes.uploadTmpImageApi,
        headers: window.axios.defaults.headers.common,
		// params: {
		// 	paramName: this.dynamicParam, // Dynamic parameter
		// },
        thumbnailHeight: 100,
        maxFilesize: this.maxFiles || 512,
		timeout: 600000, // in milliseconds = 10 minutes 
        acceptedFiles: this.acceptedFiles,
        addRemoveLinks: true,
        success: (response) => {
          if (response.status == "success") {
            const data = JSON.parse(response.xhr.response);
            // this.$emit('input', this.multiple ? [...this.value?this.value:[], data.result.file] : [data.result.file]);
            this.baseUrl = data.result.base_url;
			if(response.type.indexOf('video') !== -1)
			{
				this.pushThumbnail(response);
			}
			else
			{
				this.files = this.multiple
				  ? [...this.files, data.result.file]
				  : data.result.file;
			}

            $(response.previewElement)
              .find(".dz-remove")
              .attr("href", data.result.file);
          }
        }
      },
      error:function(file){
        console.log(file);
      },
    };
  },
  mounted() {
    // $(this.$refs['modal-1']).on("hidden.bs.modal", this.doSomethingOnHidden)
  },
  created() {
    if (!this.multiple) {
      this.dropzoneOpt.maxFiles = 1;
    }
  },
  watch: {
    // Sync localEditableVideos with editableVideos prop
    editableVideos: {
      immediate: true,
      handler(newVal) {
        this.localEditableVideos = Array.isArray(newVal) ? [...newVal] : newVal;
      },
    },
    // Emit changes to localEditableVideos to the parent
    localEditableVideos: {
      deep: true,
      handler(newVal) {
        this.$emit('update:editableVideos', newVal);
      },
    },
  },
  methods: {
    maxFileExceed(file) {
      this.$refs.proDropzone.removeFile(file);
    },
    openGallery(image){
      if(image.indexOf('.pdf') !== -1 || image.indexOf('.doc') !== -1 || image.indexOf('.zip') !== -1 || image.indexOf('.xls') !== -1 || image.indexOf('.pem') !== -1){
        window.open(image)
        return false;
      }
      if(!this.multiple){
        this.media = [{
            src: image,
            thumb: image
          }];
        this.$refs.lightbox.showImage(0);
      }else{
        const media = [...(this.editableImages || []).map(i => ({  src:this.mediaPath+'/'+i+'',thumb: this.mediaPath+'/'+i+''})) , ...(this.value || []).map(i => ({src:this.baseUrl+'/'+i,thumb:this.baseUrl+'/'+i}))];
        this.media = media.filter(m => (m.src.indexOf('.pdf') === -1 && m.src.indexOf('.doc') === -1 && m.src.indexOf('.zip') === -1 && m.src.indexOf('.xls') === -1 && m.src.indexOf('.pem') === -1));
        this.$refs.lightbox.showImage(this.media.reduce((a,i,index) => (i.src.indexOf(image)!==-1?index:a),0));
      }
    },
    checkFile(file,message){
      console.log(message);
      error_message(message)
      this.$refs.proDropzone.removeFile(file)
    },
    saveImage() {
      this.$emit(
        "input",
        this.multiple ? [...this.value, ...this.files] : this.files
      );
	  
      this.files = [];
      this.uploaded = true;
      this.$refs["my-modal-" + this.id].hide();
    },
    removeTmpFile(file, error, xhr) {
      console.log(file)
      const filename = $(file._removeLink).attr("href");
      if (!this.uploaded && file.status !== "error") {
        commonService.removeTmpImage([filename]).then((res) => {
          if (this.multiple) this.files.splice(this.files.indexOf(filename), 1);
          else this.files = "";
        });
      }
    },
    removeAllFile() {
      commonService.removeTmpImage(this.files).then((res) => {
        this.files.map((file) => {
          if (this.multiple) this.files.splice(this.files.indexOf(file), 1);
        });
        this.files = [];
        this.$emit("input", this.multiple ? this.files : "");
      });
    },
    deleteImage(value, path = null) {
      if (!path) {
        this.deleteTmpImage(value);
      } else {
        const params = { ...this.customParams, file: value };
        window.axios.post(path, params).then((res) => {
          if (res.data.result.deleted) {
            this.$emit("image-deleted", value);
            this.$toasted.success(res.data.message);
          }
        });
      }
    },
	deleteVideo(value, path = null, index) {
      if (index >= 0) {
		this.currentVideos.splice(index, 1);
		this.$emit("input", this.currentVideos);
		
      } else {
        const params = { ...this.customParams, file: value };
        window.axios.post(path, params).then((res) => {
          if (res.data.result.deleted) {
            this.$emit("video-deleted", value);
            this.$toasted.success(res.data.message);
          }
        });
      }
    },
    deleteTmpImage(value) {
      commonService.removeTmpImage([value]).then((res) => {
        if (this.multiple) {
          var data = [...this.value];
          console.log(data);
          data.splice(this.value.indexOf(value), 1);
          this.$emit("input", data);
        } else {
          this.$emit("input", "");
        }
      });
    },
	changeThumbNail(file){
      if(file.type.indexOf('pdf') !== -1){
        $(file.previewElement).find('img').attr('src',config.media_path+'images/file/pdf-icon.png');
        $(file.previewElement).find('img').attr('height',120);
        $(file.previewElement).find('.dz-details').css({opacity:0});
      }else if(file.type.indexOf('doc') !== -1){
        $(file.previewElement).find('img').attr('src',config.media_path+'images/file/doc-icon.png');
        $(file.previewElement).find('img').attr('height',120);
        $(file.previewElement).find('.dz-details').css({opacity:0});
      }else if(file.type.indexOf('zip') !== -1){
        $(file.previewElement).find('img').attr('src',config.media_path+'images/file/zippfile.png');
        $(file.previewElement).find('img').attr('height',120);
        $(file.previewElement).find('.dz-details').css({opacity:0});
      }else if(file.type.indexOf('xls') !== -1){
        $(file.previewElement).find('img').attr('src',config.media_path+'images/file/doc-xls.png');
        $(file.previewElement).find('img').attr('height',120);
        $(file.previewElement).find('.dz-details').css({opacity:0});
      }else if(file.type.indexOf('pem') !== -1){
        $(file.previewElement).find('img').attr('src',config.media_path+'images/file/keyfile.png');
        $(file.previewElement).find('img').attr('height',120);
        $(file.previewElement).find('.dz-details').css({opacity:0});
      }
	  else if(file.type.indexOf('video') !== -1){
		if (file.type.startsWith("video/")) {
			const video = document.createElement("video");
			video.src = URL.createObjectURL(file);
			video.onloadedmetadata = () => {
				const aspectRatio = video.videoWidth / video.videoHeight;
				// Check if aspect ratio is approximately 9:16
				if (Math.abs(aspectRatio - 9 / 16) > 0.01) {
					this.$refs.proDropzone.removeFile(file); // Remove invalid file
					error_message("Only videos with a 9:16 aspect ratio are allowed.")
				}
				URL.revokeObjectURL(video.src); // Release memory
			};
		}
	  }
    },
	generateThumbnail(videoUrl) 
	{
      return new Promise((resolve) => {
        const video = document.createElement("video");
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

		video.src = videoUrl;
		video.crossOrigin = "anonymous";
		video.currentTime = 1; // Capture a frame after 1 second

        video.addEventListener("loadeddata", () => {
			canvas.width = video.videoWidth / 4; // Scale down the resolution
			canvas.height = video.videoHeight / 4;
			context.drawImage(video, 0, 0, canvas.width, canvas.height);
			resolve(canvas.toDataURL("image/png"));
        });
      });
    },
    getPath(path){
      if(path.indexOf('.pdf') !== -1){
        return config.media_path+'images/file/pdf-icon.png';
      }else if(path.indexOf('.doc') !== -1){
        return config.media_path+'images/file/doc-icon.png'
      }else if(path.indexOf('.zip') !== -1){
        return config.media_path+'images/file/zippfile.png'
      }else if(path.indexOf('.xls') !== -1){
        return config.media_path+'images/file/doc-xls.png'
      }else if(path.indexOf('.pem') !== -1){
        return config.media_path+'images/file/keyfile.png'
      }

      console.log(path.split('://').length);
      if(path.split('://').length > 2){
        return path.replace(this.mediaPath+'/','')
      }
      return path;
    },
	async pushThumbnail(file)
	{
		// Create a temporary video URL from the file
		const videoUrl = URL.createObjectURL(file);
		const thumbnailBase64 = await this.generateThumbnail(videoUrl); // Assume this gives the base64 thumbnail

		// Push the video details and thumbnail into the `editableVideos` array
		this.currentVideos.push({
			filename: videoUrl,
			thumbnail: thumbnailBase64, // Add the thumbnail file here
		});

		// Convert the base64 thumbnail to a File object
		const thumbnailBlob = this.base64ToBlob(thumbnailBase64);
		const thumbnailFile = new File([thumbnailBlob], 'thumbnail.png', { type: 'image/png' });
		
		this.files = this.multiple 
		? [...this.files, { video: file, thumbnail: thumbnailFile }] 
		: [{ video: file, thumbnail: thumbnailFile }];
	},
	base64ToBlob(base64) // Utility function to convert base64 to Blob
	{
		// Remove the data URL header part (e.g., 'data:image/png;base64,')
		const base64Pattern = /^data:image\/[a-z]+;base64,/;
		const cleanedBase64 = base64.replace(base64Pattern, '').replace(/\s+/g, ''); // Remove any spaces or line breaks

		// Decode the base64 string to binary
		const binaryData = atob(cleanedBase64);
		const length = binaryData.length;
		const uint8Array = new Uint8Array(length);

		for (let i = 0; i < length; i++) {
			uint8Array[i] = binaryData.charCodeAt(i);
		}

		// Return a Blob with the appropriate MIME type for the image (e.g., PNG or JPEG)
		return new Blob([uint8Array], { type: 'image/png' });
	},
	playVideo(videoUrl) {
		window.open(videoUrl, '_blank');
	},
	onDrag(event) {
		const merged = [...this.localEditableVideos, ...this.currentVideos];
		const ordered = merged.map((item, index) => ({
			id: item.id,
			reorder: index + 1,
		}));
		this.$emit("re-order", ordered);
	}
  },
};
</script>
